var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H11.8727C12.2681 21.4331 12.5 20.7436 12.5 20V15C12.5 13.067 10.933 11.5 9 11.5H4C3.25638 11.5 2.56692 11.7319 2 12.1273V5ZM14 4.25C13.5858 4.25 13.25 4.58579 13.25 5C13.25 5.41421 13.5858 5.75 14 5.75H17.1893L12.4697 10.4697C12.1768 10.7626 12.1768 11.2374 12.4697 11.5303C12.7626 11.8232 13.2374 11.8232 13.5303 11.5303L18.25 6.81066V10C18.25 10.4142 18.5858 10.75 19 10.75C19.4142 10.75 19.75 10.4142 19.75 10V5C19.75 4.58579 19.4142 4.25 19 4.25H14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C11 21.1046 10.1046 22 9 22H5C3.34315 22 2 20.6569 2 19V15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaling);
export default __webpack_public_path__ + "static/media/scaling.8703a9e3c83c461788b4d769872dff30.svg";
export { ForwardRef as ReactComponent };